import { mergeAttributes } from "@tiptap/core";
import Image from "@tiptap/extension-image";
import { VueNodeViewRenderer } from "@tiptap/vue-3";

import ResizeableImage from "./ResizeableImage.vue";

declare module "@tiptap/core" {
  interface Commands<ReturnType> {
    ResizableImage: {
      // src: string, alt?: string, title?: string
      setImage: (_attrs: Record<string, unknown>) => ReturnType;
    };
  }
}

export default Image.extend({
  name: "ResizableImage",
  addAttributes() {
    return {
      ...this.parent?.(),
      width: {
        default: "300",
      },
      height: {
        default: 0,
      },
      float: {
        default: "none",
        rendered: false,
      },
      blobSid: {
        default: "",
        rendered: false,
      },
      href: {
        default: null,
      },
    };
  },
  renderHTML({ node }) {
    const { alt, src, float, href } = node.attrs;
    const caption = alt || "";

    const figureAttributes = {
      class: `resizable-image-float-${float}`,
      style: `float: ${float}`,
      "data-float": float,
    };

    const imgAttributes = mergeAttributes(node.attrs, {
      src,
      alt: caption,
      "data-blob-sid": node.attrs.blobSid,
    });

    const linkAttributes = {
      href: href,
      target: "_blank",
    };

    if (href) {
      return [
        "figure",
        figureAttributes,
        ["a", linkAttributes, ["img", imgAttributes]],
        ["figcaption", caption],
      ];
    } else {
      return [
        "figure",
        figureAttributes,
        ["img", imgAttributes],
        ["figcaption", caption],
      ];
    }
  },
  addCommands() {
    return {
      setImage:
        (options) =>
        ({ tr, commands }) => {
          // @ts-ignore: types are off, node exists
          if (tr.selection?.node?.type?.name == "ResizableImage") {
            // update float: left/none/right attribute
            return commands.updateAttributes("ResizableImage", options);
          } else {
            // insert <img> tag
            return commands.insertContent({
              type: this.name,
              attrs: options,
            });
          }
        },
    };
  },
  addNodeView() {
    return VueNodeViewRenderer(ResizeableImage);
  },
});
